module.exports = __webpack_public_path__ + "static/media/trademark.0003605b.svg";